import {Component, OnInit, ViewChild }from '@angular/core'; 
import {NgForm }from '@angular/forms'; 
import {ActivatedRoute, Router }from '@angular/router'; 
import {ConfirmationService, Message }from 'primeng/api'; 
import {AppBreadcrumbService }from 'src/app/app.breadcrumb.service'; 
import {LookupValuesService }from 'src/app/common/lookup-values.service'; 
import {ValidateformComponent }from 'src/app/common/validateform/validateform.component'; 
import {MemberService }from 'src/app/services/MemberService'; 
import { Location } from '@angular/common';
import { AlertService } from 'src/app/services/AlertService';
@Component( {
  selector:'app-member-add', 
  templateUrl:'./member-add.component.html', 
  styleUrls:['./member-add.component.scss']
})
export class MemberAddComponent implements OnInit {

  @ViewChild('f', { static: true }) addMemberForm: NgForm;
  @ViewChild(ValidateformComponent, { static: true })
  private formValidator: ValidateformComponent;
  member:any; 
  options:any; 
  memberTypeOptions:any[] = []; 
  officeTypeOptions:any[] = []; 
  countryOptions:any[] = []; 
  stateOptions:any[] = []; 
  parentOfficeOptions:any[] = []; 
  msgs:Message[]; 

  constructor(private router:Router, 
    private activatedRoute:ActivatedRoute, 
    private breadcrumbService:AppBreadcrumbService, 
    private lookupValuesService:LookupValuesService, 
    private memberservice:MemberService, 
    private confirmationService:ConfirmationService,
    private location: Location,
    private alertService: AlertService) {}
    public disableParentOfficedDropDown = false;
  ngOnInit():void {

    this.options = this.activatedRoute.snapshot.data['options'] 
    this.parseOptions(); 
    this.initForm();

    this.breadcrumbService.setItems([this.breadcrumbService.member]); 
  }
  initForm() {   
    this.member = { Name: '', OfficeTypeID: '' , Address: '', Address2: '', City: '', StateID: '', PostalCode: '', CountryID: '', OfficePhone: '', OfficeFax: '', OfficeEmail:'',
    OfficeWebsite:'', MarketAreaDescription:'', AboutUs:'', ExclusivityArea: '', Profile: '', ProfessionalDesignations: '', BrokerageServices: '', LinkedInURL: '', ParentMemberId: '', 
    FacebookID: '', TwitterID: '', YoutubeID: '', Instagram: '', BlogUrl: '', BlogRSSFeedUrl: '', SEOName: '', MemberTypeID: '' };
    this.disableParentOfficedDropDown = true;

  }

  parseOptions() {

    this.memberTypeOptions = new Array(); 
    for (let o of this.options[0]) {
        let l = o.Name; 
        this.memberTypeOptions.push( {label:l, value:o.Id }); 
    }

    this.officeTypeOptions = new Array(); 
    for (let o of this.options[1]) {
        let l = o.Name; 
        this.officeTypeOptions.push( {label:l, value:o.Id }); 
    }

    this.countryOptions = new Array(); 
    for (let o of this.options[2]) {
        let l = o.Name; 
        this.countryOptions.push( {label:l, value:o.Id }); 
    }
    this.parentOfficeOptions = new Array(); 
    for (let o of this.options[3]) {
        let l = o.Name; 
        this.parentOfficeOptions.push( {label:l, value:o.Id }); 
    }

      
  }
  onCountryChange() {
    if (this.member.CountryID != null) {
        this.lookupValuesService.GetStateOptions(this.member.CountryID).subscribe(
            res =>  {
                this.stateOptions = new Array(); 
                for (let o of res) {
                    let l = o.Name; 
                    this.stateOptions.push( {label:l, value:o.Id }); 
                }
            })
    }
  }
  onOfficeTypeChange()
  {
    if(this.member.OfficeTypeID != null)
    {
       if(this.member.OfficeTypeID == 1)
       {
          this.disableParentOfficedDropDown = true; 
       }
       else
       {
          this.disableParentOfficedDropDown = false; 
       }
    }
  }

  cancelAddMember() {
  this.location.back();
  }

  addMember() {                     
     
    if (this.formValidator.validateForm()) {
        this.memberservice.AddMember(this.member).subscribe(
            result => {
                if (result.Id != null) {       
                  this.router.navigate(['/member/'+ result.Id])                              
                }
                else {
                    this.alertService.SetMessage('error', 'There is an error while adding a new member');
                }                  
            },
            error => {                
                    this.alertService.SetMessage('error', 'There is an error while a new member');
            }
        );
    }
  }
}
